
export const hpStations = [];


export const getHpStationName = (station) =>
  `${station.company} - ${station.stationTitle}, ${station.address}`;


export const countHpSegments = () =>
  hpStations.reduce(
    (total, station) => total + station.segmentTitles.length,
    0,
  );
